export default __webpack_public_path__ + "static/media/OurDelight_3.db2fc04b.png";